export const VwfsSourceType = {
    Cebia: 1,
    Target: 2,
    Profin: 3,
} as const
export type VwfsSourceType = typeof VwfsSourceType[keyof typeof VwfsSourceType]

export const VwfsSourceTypes: [VwfsSourceType, string][] = [
    [VwfsSourceType.Cebia, 'Cebia'],
    [VwfsSourceType.Target, 'Target'],
    [VwfsSourceType.Profin, 'Profin'],
]
